import { RootState } from '../types'

export const getMainSectionSelector = (state: RootState) => state.section
export const getSectionsSelector = (state: RootState) => state.section.sections
